import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * SpaLink — a real, crawlable anchor for internal single-page-app navigation.
 *
 * Renders an actual <a href="{to}"> so search engines and AI crawlers can
 * discover and follow the link (and so it is keyboard-focusable), while still
 * doing client-side routing on a normal left-click. Modifier clicks
 * (Cmd/Ctrl/Shift/Alt) and non-left buttons fall through to native browser
 * behavior, so "open in new tab" and middle-click still work.
 *
 * Props:
 *   to        — internal path to navigate to (e.g. "/guides")
 *   onClick   — optional extra handler run before navigation
 *   ...rest   — style, className, aria-*, etc. are passed straight to the <a>
 */
const SpaLink = ({ to, onClick, children, ...rest }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) onClick(e);
    // Let the browser handle new-tab / new-window / download intents natively.
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
    ) {
      return;
    }
    e.preventDefault();
    navigate(to);
  };

  return (
    <a href={to} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export default SpaLink;
